import { OPEN_MODAL_PRODUCT } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (value) => companyUsersActions[OPEN_MODAL_PRODUCT](value);
